import script from "./RatingStars.vue?vue&type=script&setup=true&lang=ts"
export * from "./RatingStars.vue?vue&type=script&setup=true&lang=ts"

import "./RatingStars.vue?vue&type=style&index=0&id=62643b10&lang=scss&scoped=true"

import exportComponent from "/builds/maqqie/maqqie-client-portal/clientportal-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62643b10"]])

export default __exports__